import { Template1Styles, Template2Styles } from 'components/ResumeBuilder/Stylesheets';
import { Template1, Template2 } from 'components/ResumeBuilder/Templates';

export const AVAILABLE_TEMPLATES: any = [
	{
		id: 1,
		slug: 'template-1',
		name: 'Modern Resume',
		component: Template1,
		styles: Template1Styles,
	},
	{
		id: 2,
		slug: 'template-2',
		name: 'Template Resume',
		component: Template2,
		styles: Template2Styles,
	},
];
